
import { ChargingStation } from '@/types/task';
import { Card, CardContent } from '@/components/ui/card';
import { BadgeCheck, Zap, Home, MapPin } from 'lucide-react';

interface StationStatsProps {
  stations: ChargingStation[];
}

const StationStats = ({ stations }: StationStatsProps) => {
  // Calculate stats
  const totalStations = stations.length;
  const availableStations = stations.filter(station => station.available).length;
  const homeChargers = stations.filter(station => station.isHomeCharger).length;
  const fastChargers = stations.filter(station => 
    station.chargerType === 'fast' || station.chargerType === 'ultra-fast'
  ).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <StatCard 
        icon={<MapPin className="h-5 w-5 text-blue-500" />}
        title="Total Stations"
        value={totalStations}
        description="Charging stations"
      />
      
      <StatCard 
        icon={<BadgeCheck className="h-5 w-5 text-green-500" />}
        title="Available"
        value={availableStations}
        description="Ready to use"
      />
      
      <StatCard 
        icon={<Home className="h-5 w-5 text-purple-500" />}
        title="Home Chargers"
        value={homeChargers}
        description="Peer-to-peer charging"
      />
      
      <StatCard 
        icon={<Zap className="h-5 w-5 text-amber-500" />}
        title="Fast Chargers"
        value={fastChargers}
        description="High-power charging"
      />
    </div>
  );
};

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: number;
  description: string;
}

const StatCard = ({ icon, title, value, description }: StatCardProps) => {
  return (
    <Card className="overflow-hidden border border-gray-100 transition-all hover:shadow-md bg-white">
      <CardContent className="p-4">
        <div className="flex items-center mb-2">
          {icon}
          <span className="text-sm font-medium ml-2 text-gray-500">{title}</span>
        </div>
        <div className="text-2xl font-bold">{value}</div>
        <div className="text-xs text-muted-foreground">{description}</div>
      </CardContent>
    </Card>
  );
};

export default StationStats;
